import React, { useEffect, useState, useContext } from "react";
import {  Route, Switch } from "react-router-dom";
import { EncryptStorage } from "encrypt-storage";
import Axios from "axios";
import DocumentFolderList from "./_partials/DocumentFolderList/DocumentFolderList";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import NotifyAttorney from "../DocumentsV2/components/NotifyAttorney";

async function asyncForEach(array, callback){
    for (let index = 0; index < array.length; index++){
        await callback(array[index], index, array);
    }
}

function DocumentPage(){
    const encryptStorage                = new EncryptStorage("secret-key");
    const decypt_data                   = encryptStorage.getItem("case_details");
    const data                          = decypt_data;
    const client_case_id                = data ? data.case.id : null;
    const defaultFolders                = [];
    const [routes, setRoutes]           = useState([]);
    const [notif, showNotif]            = useState(false);
    const [notifMsg, setNotifMsg]       = useState("File Downloading");
    
    const defaultRoutes = [
        {
            id:0,
            client_case_id:client_case_id,
            section_name:'My Documents',
            section_id: 'mydocuments',
            isParent:1,
            Parent:0,
            Type:'Folder',
            created_by: 'Default',
        },
    ];

    let dataProps = {
        client_case_id:client_case_id,
        allFolders:routes,
        defaultFolders:defaultRoutes,
        setRoutes:setRoutes,
        showNotif:showNotif,
        setNotifMsg:setNotifMsg,
    }

    const handleCloseNotif = () => {
        showNotif(false);
    }

    const getCustomFolders = async()=>{
        /**
         * Fetch all Custom Sections for Route
         * @param client_case_id
         */
        await Axios.get(`api/documents/section/list/${client_case_id}`)
        .then(async(res) => {
            /**
             * Make Default Routes as Default Folders
             * @param defaultFolders
             */
            await asyncForEach(defaultRoutes, async(folder) => {
                defaultFolders.push(folder);
            });
            /**
             * Make Custom Folders as Default Folders
             * @param res.data.data
             */
            await asyncForEach(res.data.data, async(file) =>{
                defaultFolders.push(file)
            });
            setRoutes(defaultFolders);
        })
        .catch((e)=>{
            console.log(e);
        })
    }

    useEffect(()=>{
        getCustomFolders();
    }, []);

    return(
        <div id="documentsPage" className="row" style={{ gap: '20px'}}>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="d-flex flex-column">
                                <h3 className="m-0 text-dark font-weight-bolder">Documents</h3>
                                <span class="text-muted mt-0 font-weight-bold font-size-sm">
                                    Case Related Documents
                                </span>
                            </div>
                            <div className="ml-auto">
                                <NotifyAttorney />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <Switch>
                            {
                            routes.map((route, index) => (
                                <Route 
                                path={'/documents/'+route.section_id}
                                render={(props) => (
                                    <DocumentFolderList props={dataProps} folder={route}/>
                                )}
                                />
                            ))
                            }
                        </Switch>
                    </div>
                </div>
            </div>

            <Snackbar
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
                }}
                open={notif}
                onClose={handleCloseNotif}
                message={notifMsg}
                action={
                <React.Fragment>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseNotif}>
                    <CloseIcon fontSize="small" />
                    </IconButton>
                </React.Fragment>
                }
            />
        </div>
    )
    

}
export default DocumentPage